import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";
import { mapLiveSessionsListData } from "../mappers";

export default function liveSessionsListReducer(
  state = InitialStates.getInitialLiveSessionsListState(),
  action
) {
  switch (action?.type) {
    case Constants.GET_LIVE_SESSIONS_LIST: {
      const {
        liveSessionsList,
        liveSessionsListNextPage,
        isLastLiveSessionsListPage,
        ...initialState
      } = InitialStates.getInitialLiveSessionsListState();
      return {
        ...initialState,
        liveSessionsList: state?.liveSessionsList || liveSessionsList,
        liveSessionsListNextPage: state?.liveSessionsListNextPage || liveSessionsListNextPage,
        isLastLiveSessionsListPage: state?.isLastLiveSessionsListPage || isLastLiveSessionsListPage,
        liveSessionsListPageSize: action.pageSize || 0,
        loading: true,
      };
    }
    case Constants.GET_LIVE_SESSIONS_LIST_SUCCESS: {
      const data = action.payload?.liveSessions;
      return {
        ...InitialStates.getInitialLiveSessionsListState(),
        liveSessionFetchSuccess: true,
        liveSessionsListPageSize: state?.liveSessionsListPageSize,
        liveSessionsListNextPage: state?.liveSessionsListNextPage + 1,
        isLastLiveSessionsListPage: data?.length < state?.liveSessionsListPageSize,
        ...mapLiveSessionsListData(data, state?.liveSessionsList),
      };
    }
    case Constants.GET_LIVE_SESSIONS_LIST_ERROR: {
      return {
        ...InitialStates.getInitialLiveSessionsListState(),
        errorFetching: true,
      };
    }
    default:
      return state;
  }
}
